import {createReducer, createActions} from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  filtersInterestRequest: null,
  filtersInterestLanguageRequest: null,
  filtersInterestCategoryRequest: ['language'],
  filtersInterestInterestRequest: ['language', 'search'],
  filtersInterestInterestReset: null,
  filtersInterestSuccess: ['result'],
  filtersInterestFailure: ['error'],

  filtersInterestAddToList: ['propName', 'value'],
  filtersInterestRemoveFromList: ['propName', 'value'],
  filtersInterestSet: ['propName', 'value'],

  filtersInterestReset: null,
  filtersInterestFetchingReset: null,
})

export const FiltersInterestTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  result: {
    languages: null,
    categories: null,
    interests: null,
  },
  error: null,
  fetching: false,
  fetchingInterests: false,

  language: 1,
  category: null,
  tags: [],
})

/* ------------- Selectors ------------- */

export const FiltersSelectors = {
  getFilters: state => state.filtersInterest,
}

/* ------------- Reducers ------------- */

export const filtersInterestRequest = state => {
  return state.merge({fetching: true, error: null})
}

export const filtersInterestLanguageRequest = state => {
  return state.merge({fetching: true, error: null})
}

export const filtersInterestCategoryRequest = (state, {language}) => {
  return state.merge({fetching: true, error: null})
}

export const filtersInterestInterestRequest = (state, {language, search}) => {
  return state.merge({fetching: true, fetchingInterests: true, error: null})
}

export const filtersInterestSuccess = (state, {result}) => {
  return state.merge({fetching: false, fetchingInterests: false, error: null, result: {...state.result, ...result}})
}

export const filtersInterestFailure = (state, {error}) => {
  return state.merge({fetching: false, error})
}

export const filtersInterestFetchingReset = state => {
  return state.merge({fetching: false, fetchingInterests: false})
}

export const filtersInterestInterestReset = state => {
  return state.merge({result: {...state.result, interests: null}})
}

export const filtersInterestReset = state => {
  return state.merge({
    previousTags: [...state.tags],
    tags: [...INITIAL_STATE.tags],
  })
}

export const filtersInterestAddToList = (state, {propName, value}) => {
  let i = 0
  const list = state[propName]
  const newList = []
  for (i = 0; i < list.length; i++) {
    newList.push(list[i])
  }
  newList.push(value)
  return state.set(propName, newList)
}

export const filtersInterestRemoveFromList = (state, {propName, value}) => {
  let i = 0
  let newList = []
  for (i = 0; i < state[propName].length; i++) {
    if (state[propName][i] === value) continue
    newList.push(state[propName][i])
  }
  return state.set(propName, newList)
}

export const filtersInterestFilterSet = (state, {propName, value}) => {
  if (propName === 'tags') {
    return state.merge({tags: value, previousTags: null})
  }
  if (Array.isArray(propName)) {
    const data = {}
    for (let i in propName) {
      data[propName[i]] = value[i]
    }

    return state.merge({...data})
  } else {
    return state.set(propName, value)
  }
}

/* ------------- Hookup Reducers To Types ------------- */
//processStatusRequest
export const reducer = createReducer(INITIAL_STATE, {
  [Types.FILTERS_INTEREST_REQUEST]: filtersInterestRequest,
  [Types.FILTERS_INTEREST_LANGUAGE_REQUEST]: filtersInterestLanguageRequest,
  [Types.FILTERS_INTEREST_CATEGORY_REQUEST]: filtersInterestCategoryRequest,
  [Types.FILTERS_INTEREST_INTEREST_REQUEST]: filtersInterestInterestRequest,
  [Types.FILTERS_INTEREST_SUCCESS]: filtersInterestSuccess,
  [Types.FILTERS_INTEREST_FAILURE]: filtersInterestFailure,

  [Types.FILTERS_INTEREST_ADD_TO_LIST]: filtersInterestAddToList,
  [Types.FILTERS_INTEREST_REMOVE_FROM_LIST]: filtersInterestRemoveFromList,
  [Types.FILTERS_INTEREST_SET]: filtersInterestFilterSet,

  [Types.FILTERS_INTEREST_RESET]: filtersInterestReset,

  [Types.FILTERS_INTEREST_FETCHING_RESET]: filtersInterestFetchingReset,
  [Types.FILTERS_INTEREST_INTEREST_RESET]: filtersInterestInterestReset,
})
